import Anchor from './anchor';
import AnchorLink from './anchor-link';

Anchor.AnchorLink = AnchorLink;

export default Anchor;
